import { useSyncExternalStore } from 'react';

/** How long a freshly submitted entry stays highlighted in the seller's list. */
const HIGHLIGHT_MS = 6_000;

/**
 * The id of the entry the seller just submitted, so their own list can point at
 * it. The drawer lives in AppShell and the list in SellerHomePage — siblings
 * with no shared owner — so this tiny store is the channel rather than threading
 * state through two separate <Outlet/> render sites.
 */
let currentId: string | null = null;
let timer: ReturnType<typeof setTimeout> | null = null;
const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) listener();
}

export function markJustSubmitted(id: string): void {
  currentId = id;
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    currentId = null;
    timer = null;
    emit();
  }, HIGHLIGHT_MS);
  emit();
}

export function useJustSubmittedId(): string | null {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => currentId,
    () => null, // SSR/prerender: never highlight
  );
}
